var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#EDF2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17ZM15 24C15 19.0294 19.0294 15 24 15C28.9706 15 33 19.0294 33 24C33 28.9706 28.9706 33 24 33C19.0294 33 15 28.9706 15 24Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9428 28.9429C29.3333 28.5524 29.9665 28.5524 30.357 28.9429L34.707 33.2929C35.0975 33.6834 35.0975 34.3166 34.707 34.7071C34.3165 35.0977 33.6833 35.0977 33.2928 34.7071L28.9428 30.3571C28.5523 29.9666 28.5523 29.3334 28.9428 28.9429Z",
    fill: "#2C3E50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20C24.5523 20 25 20.4477 25 21V27C25 27.5523 24.5523 28 24 28C23.4477 28 23 27.5523 23 27V21C23 20.4477 23.4477 20 24 20Z",
    fill: "#2C3E50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 24C20 23.4477 20.4477 23 21 23H27C27.5523 23 28 23.4477 28 24C28 24.5523 27.5523 25 27 25H21C20.4477 25 20 24.5523 20 24Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.eace2d63aced369b5a302df08f022b44.svg";
export { ForwardRef as ReactComponent };